import {Button, Icon} from "antd";
import * as React from 'react';
import {withRouter, RouteComponentProps} from 'react-router';

import HollandClient, { Question } from '../../api/HollandClient';
import Header from "../../components/Header/Header";

import HollandQuestion from '../../components/HollandQuestion/HollandQuestion';
import {connect, GlobalProps} from '../../stores/GlobalStore';

export interface State{
  questions: Question[],
  answers: string[],
  currentQuestion: number,
  started: boolean,
}

import styles from './HollandPage.module.scss';
class HollandPage extends React.Component<{} & RouteComponentProps & GlobalProps, State>{

  public state = {
    questions: [],
    answers: Array(30).fill(-1),
    currentQuestion: 0,
    started: false
  };

  public render(){

    const { questions, currentQuestion, started } = this.state;

    return (
      <div className={styles.hollandPage}>
        <Header page={'Holland'} reloadable={false}/>
        {!started && (
          <div style={{textAlign: 'center'}}>
            <p>
              <strong>Instruções:</strong>
              Seguindo as notas da tabela, atribua o seu grau de afinidade em relação a cada característica
              ou situação apresentada.
              Responda seguindo sua tendência natural e espontânea de reagir - e não como gostaria de reagir à situação.
              Total: 30 questões.  Ao final consulte o gráfico sobre as 6 estruturas vocacionais de Holland.
            </p>
            <Button type="primary" onClick={this.start}>
              Começar <Icon type="check" />
            </Button>
          </div>
        )}


        {started && (
          <>
            <strong>Escala de afinidade</strong>
            <ul className={styles.legend}>
              <li>0 - Nunca sou assim</li>
              <li>1 - Raras vezes sou assim</li>
              <li>2 - Às vezes sou assim</li>
              <li>3 - Regularmente sou assim</li>
              <li>4 - Na maior parte das vezes sou assim</li>
              <li>5 - Sou 100% assim!!!!</li>
            </ul>
          </>
        )}

        {started && questions.map((question: Question, index: number) =>
          ( currentQuestion === index &&
            <HollandQuestion
              question={question}
              indice={index + 1}
              key={question._id}
              nextQuestion={this.nextQuestion}
              prevQuestion={this.prevQuestion}
              lastQuestion={index === questions.length - 1}
              onSelectAnswer={this.onSelectAnswer}
              finish={this.finish}
              index={index}
              selectedValue={this.state.answers[index]}
            />
          )
        )}
      </div>
    )
  }

  public async componentDidMount(){
    const {questions} = await HollandClient().findAll();

    this.setState({
      questions
    });
  }

  private start = () => {
    this.setState({
      started: true
    });
  };

  private nextQuestion = () => {

    const { currentQuestion, questions } = this.state;

    this.setState({
      currentQuestion: currentQuestion === questions.length - 1? currentQuestion : currentQuestion + 1
    });
  };

  private prevQuestion = () => {

    const { currentQuestion } = this.state;

    this.setState({
      currentQuestion: currentQuestion ? currentQuestion - 1 : 0
    });
  };

  private onSelectAnswer = (answer: any) => {
    this.setState({
      answers: replaceAt(this.state.answers, answer.index, answer.valor)
    });
  };

  private finish = async () => {
    const response = await HollandClient().calculateProfile({
      list: this.state.answers,
      token: this.props.authToken
    });

    if(response){
      this.props.history.push('/');
    }
  };

}

function replaceAt(array: any[], index: number, value: string) {
  const ret = array.slice(0);
  ret[index] = value;
  return ret;
}

export default withRouter(connect(HollandPage, 'authToken'));

